import { ERROR_USER_REGISTERED } from '@/config';

import { THttpService } from '@/services/HttpService';

import { validateCpf } from '@/helpers/ValidateHelper';
import { getValue } from '@/helpers/GetValueHelper';

import { TTOptinInput } from './types';

const formatSuccess = () => {
  return 'success';
};

const formatError = () => {
  return 'error';
};

const formatWarning = () => {
  return 'warning';
};

export const submitOptin = async (
  api: THttpService,
  params: TTOptinInput,
): Promise<string> => {
  const path = `/b2c/member-promotional/promotionals/optin`;

  const key = validateCpf(params.cpfOrMemberNumber) ? 'cpf' : 'memberNumber';
  const data = {
    promotionId: params.promotionId,
    [key]: params.cpfOrMemberNumber,
  };

  try {
    await api.post(`${path}`, data);
    return formatSuccess();
  } catch (error) {
    const isRegistered = getValue(error, 'response.data.data.error_code', '');
    return `${isRegistered}` === ERROR_USER_REGISTERED
      ? formatWarning()
      : formatError();
  }
};
